import { Card, CardContent } from "@/components/ui/card";

export function MatchupsTab({ round, PAR_3_HOLES, isVuelta1 }) {
  return (
    <div className="space-y-4">
      {round?.matchups?.map((matchup, index) => {
        const secPlayers = matchup.secondary_pair.map(id => 
          round.players.find(p => p.player_id === id)
        );
        const isBaseWinner = matchup.total_points > 0;
        const isTie = matchup.total_points === 0;

        return (
          <Card key={index} className="card-default">
            <CardContent className="p-4">
              {/* Matchup Header */}
              <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-100">
                <div>
                  <p className="text-xs text-[#64748B]">Enfrentamiento {index + 1}</p>
                  <p className="font-semibold text-[#0F172A]">
                    Base vs {secPlayers.map(p => p?.name?.split(' ')[0]).join(' + ')}
                  </p>
                  <p className="text-xs text-[#64748B] mt-1">
                    Ventaja: {matchup.handicap_advantage} golpes a {matchup.advantage_to === 'base' ? 'Base' : matchup.advantage_to === 'secondary' ? 'Secundarios' : 'Ninguno'}
                  </p>
                </div>
                <div className="text-right space-y-1">
                  <div className="flex items-center gap-2 text-xs text-[#64748B]">
                    <span>V1: <span className={`font-semibold ${(matchup.vuelta1_points || 0) > 0 ? 'text-green-600' : (matchup.vuelta1_points || 0) < 0 ? 'text-red-600' : ''}`}>
                      {(matchup.vuelta1_points || 0) > 0 ? '+' : ''}{matchup.vuelta1_points || 0}
                    </span></span>
                    <span>V2: <span className={`font-semibold ${(matchup.vuelta2_points || 0) > 0 ? 'text-green-600' : (matchup.vuelta2_points || 0) < 0 ? 'text-red-600' : ''}`}>
                      {(matchup.vuelta2_points || 0) > 0 ? '+' : ''}{matchup.vuelta2_points || 0}
                    </span>
                    {matchup.is_doubled && <span className="text-[10px] bg-amber-100 text-amber-700 px-1 rounded">x2</span>}
                    </span>
                  </div>
                  <div className={`px-3 py-1 rounded-lg inline-block ${
                    isBaseWinner ? 'bg-green-50' : isTie ? 'bg-gray-50' : 'bg-red-50'
                  }`}>
                    <p className={`text-xl font-bold ${
                      isBaseWinner ? 'text-green-600' : isTie ? 'text-gray-500' : 'text-red-600'
                    }`}>
                      {matchup.total_points > 0 ? '+' : ''}{matchup.total_points}
                    </p>
                  </div>
                </div>
              </div>

              {/* Hole by Hole Results - Split by vuelta */}
              {[1, 2].map(vuelta => {
                const vHoles = Object.entries(matchup.hole_results || {}).filter(([hole]) => 
                  vuelta === 1 ? isVuelta1(parseInt(hole)) : !isVuelta1(parseInt(hole))
                );
                if (vHoles.length === 0) return null;
                const vTotal = vuelta === 1 ? (matchup.vuelta1_points || 0) : (matchup.vuelta2_points || 0);
                return (
                  <div key={vuelta} className="mb-3">
                    <div className="flex items-center justify-between mb-1">
                      <p className="text-xs font-semibold text-[#64748B]">
                        {vuelta === 1 ? '1ra' : '2da'} Vuelta
                        {vuelta === 2 && matchup.is_doubled && <span className="ml-1 text-[10px] bg-amber-100 text-amber-700 px-1 py-0.5 rounded">DOBLE</span>}
                      </p>
                      <p className={`text-xs font-bold ${vTotal > 0 ? 'text-green-600' : vTotal < 0 ? 'text-red-600' : 'text-gray-500'}`}>
                        {vTotal > 0 ? '+' : ''}{vTotal}
                      </p>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs">
                        <thead>
                          <tr className="border-b border-gray-200">
                            <th className="text-left py-2 px-1 text-[#64748B]">Hoyo</th>
                            {vHoles.map(([hole]) => (
                              <th key={hole} className="text-center py-2 px-1 text-[#64748B] min-w-[50px]">{hole}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-b border-gray-100">
                            <td className="py-2 px-1 font-medium text-[#1B4D3E]">B. Baja</td>
                            {vHoles.map(([hole, result]) => (
                              <td key={hole} className={`text-center py-2 px-1 ${
                                result.low_ball?.points > 0 ? 'text-green-600 font-semibold' : 
                                result.low_ball?.points < 0 ? 'text-red-600 font-semibold' : 'text-gray-500'
                              }`}>
                                {result.low_ball?.base}-{result.low_ball?.sec}
                                <span className="block text-[10px]">
                                  ({result.low_ball?.points > 0 ? '+' : ''}{result.low_ball?.points})
                                </span>
                              </td>
                            ))}
                          </tr>
                          <tr className="border-b border-gray-100">
                            <td className="py-2 px-1 font-medium text-[#D4A373]">B. Alta</td>
                            {vHoles.map(([hole, result]) => (
                              <td key={hole} className={`text-center py-2 px-1 ${
                                result.high_ball?.points > 0 ? 'text-green-600 font-semibold' : 
                                result.high_ball?.points < 0 ? 'text-red-600 font-semibold' : 'text-gray-500'
                              }`}>
                                {result.high_ball?.base}-{result.high_ball?.sec}
                                <span className="block text-[10px]">
                                  ({result.high_ball?.points > 0 ? '+' : ''}{result.high_ball?.points})
                                </span>
                              </td>
                            ))}
                          </tr>
                          <tr className="border-b border-gray-100 bg-[#D4A373]/10">
                            <td className="py-2 px-1 font-medium text-[#92400e]">Unidades</td>
                            {vHoles.map(([hole, result]) => {
                              const unitPts = result.unit_points || 0;
                              return (
                                <td key={hole} className={`text-center py-2 px-1 ${
                                  unitPts > 0 ? 'text-green-600 font-semibold' : 
                                  unitPts < 0 ? 'text-red-600 font-semibold' : 'text-gray-400'
                                }`}>
                                  {unitPts !== 0 ? (unitPts > 0 ? '+' + unitPts : unitPts) : '-'}
                                </td>
                              );
                            })}
                          </tr>
                          <tr className="border-b border-gray-100 bg-amber-50">
                            <td className="py-2 px-1 font-medium text-amber-700">Oyes</td>
                            {vHoles.map(([hole, result]) => {
                              const oyesPts = result.oyes_points || 0;
                              const isPar3 = PAR_3_HOLES.includes(parseInt(hole));
                              return (
                                <td key={hole} className={`text-center py-2 px-1 ${
                                  !isPar3 ? 'text-gray-300' :
                                  oyesPts > 0 ? 'text-green-600 font-semibold' : 
                                  oyesPts < 0 ? 'text-red-600 font-semibold' : 'text-gray-400'
                                }`}>
                                  {!isPar3 ? '-' : oyesPts !== 0 ? (oyesPts > 0 ? '+' + oyesPts : oyesPts) : '0'}
                                </td>
                              );
                            })}
                          </tr>
                          <tr className="bg-gray-50">
                            <td className="py-2 px-1 font-bold">Total</td>
                            {vHoles.map(([hole, result]) => (
                              <td key={hole} className={`text-center py-2 px-1 font-bold ${
                                result.hole_points > 0 ? 'text-green-600' : 
                                result.hole_points < 0 ? 'text-red-600' : 'text-gray-500'
                              }`}>
                                {result.hole_points > 0 ? '+' : ''}{result.hole_points}
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
